import React from "react";
import { Header, SlideLayout } from "../../shared-components";
import { IconVariant } from "../../shared-components/Header";

export const DownloadConfirmationSlide = ({ browser }: { browser: string }) => {
  return (
    <SlideLayout>
      <Header iconVariant={IconVariant.Check}> You've installed Clockwise for {browser}</Header>
    </SlideLayout>
  );
};
